import { alpha } from '@mui/material/styles'

export default function MenuItem(theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: alpha(theme.palette.primary.light, 0.3),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.light, 0.5),
            },
          },
        },
      },
    },
  }
}
